import { Injectable } from '@angular/core';


@Injectable()
export class ShowCreditPaymentForPlanService {


  static isShowCreditType = true;
}
